import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  roomBooking: {
    data: [],
    meta: {
      total: 0,
    },
  },
  mainRoomBooking: [],
};

// TODO: fetch all the roomBooking
export const fetchRoomBooking = createAsyncThunk(
  "fetchRoomBooking/roomBooking",
  async ({ enqueueSnackbar, limit = 10, page = 0, filter }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`room-booking`, {
        params: {
          limit,
          page: page + 1,
          filter: filter || undefined,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create roomBooking
export const createRoomBooking = createAsyncThunk(
  "createRoomBooking/roomBooking",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`room-booking`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update roomBooking
export const updateRoomBooking = createAsyncThunk(
  "updateRoomBooking/roomBooking",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`room-booking/${id}`, data);
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateRoomBookingStatus = createAsyncThunk(
  "roomBooking/updateRoomBookingStatus",
  async ({ id, status, enqueueSnackbar, setRefresh }, { rejectWithValue }) => {
    try {
      // Replace with your API endpoint for updating booking status
      const response = await axiosInstance.patch(`/room-booking/${id}`, {
        status,
      });
      enqueueSnackbar("Booking status updated successfully", {
        variant: "success",
      });
      setRefresh((prev) => !prev); // Trigger table refresh
      return { id, status };
    } catch (error) {
      enqueueSnackbar("Failed to update booking status", { variant: "error" });
      return rejectWithValue(error.message);
    }
  }
);

// TODO: delete roomBooking
export const deleteRoomBooking = createAsyncThunk(
  "deleteRoomBooking/roomBooking",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`room-booking/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const roomBookinglice = createSlice({
  name: "roomBooking",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get roomBooking
    builder.addCase(fetchRoomBooking.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRoomBooking.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.roomBooking.data = action.payload.data;
      state.roomBooking.meta.total = action.payload.meta.total;
    });

    builder.addCase(fetchRoomBooking.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(action.payload.error.message, {
          variant: "error",
        });
    });

    // TODO: create roomBooking
    builder.addCase(createRoomBooking.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createRoomBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roomBooking.data = [action.payload.data, ...state.roomBooking.data];
      state.roomBooking.meta.total = state.roomBooking.meta.total + 1;
      action.payload.enqueueSnackbar("RoomBooking is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createRoomBooking.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update roomBooking
    builder.addCase(updateRoomBooking.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateRoomBooking.fulfilled, (state, action) => {
      state.isLoading = false;

      state.roomBooking.data = state?.roomBooking?.data?.map((roomBooking) => {
        if (roomBooking.id === action.payload.data.data.id) {
          return action.payload.data.data;
        } else {
          return roomBooking;
        }
      });
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar("RoomBooking is updated successfully.", {
          variant: "success",
        });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateRoomBooking.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete roomBooking
    builder.addCase(deleteRoomBooking.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteRoomBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      // state.roomBooking.data = state.roomBooking.data.filter(
      //   (roomBooking) => roomBooking.id !== action.payload.data
      // );
      action.payload.enqueueSnackbar("RoomBooking is cancelled successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteRoomBooking.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default roomBookinglice.reducer;

export const { resetLoadings } = roomBookinglice.actions;
